// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__28kBP","header":"MergedInvoice_header__1QynO"};